import { render } from "./RkaAddress.vue?vue&type=template&id=68592665&scoped=true"
import script from "./RkaAddress.vue?vue&type=script&lang=js"
export * from "./RkaAddress.vue?vue&type=script&lang=js"

import "./RkaAddress.vue?vue&type=style&index=0&id=68592665&scoped=true&lang=css"
import "./RkaAddress.vue?vue&type=style&index=1&id=68592665&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68592665"]])

export default __exports__